<template>
  <b-modal
    modal-class="confirm-modal"
    :title="title"
    ref="dialog"
    @ok="$emit('ok')"
    cancel-variant="link text-secondary"
    :ok-variant="okVariant"
    :ok-title="okTitle"
    :visible="value"
    ok-only
    hide-header-close
  >
    <!-- @slot This contains the body of confirmation dialog -->
    <slot></slot>
  </b-modal>
</template>

<script>
import { BModal } from 'bootstrap-vue'

/**
 * This shows an alert dialog
 */
export default {
  name: 'Alert',
  props: {
    /**
     * title of OK button
     */
    okTitle: { default: 'OK', type: String },
    /**
     * See different variants at https://bootstrap-vue.org/docs/components/button
     */
    okVariant: { default: 'primary', type: String },
    /**
     * Header title
     */
    title: { type: String },
    value: { type: Boolean }
  },
  components: {
    BModal
  },
  methods: {
    show() {
      this.$refs.dialog.show()
    }
  }
}
</script>

<style lang="scss" scoped></style>
